import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import { BillingTypeSelect } from '../../../../Resume/components/Detail/components/BillingTypeSelect';

import { AddedProductResponsiveItemCoesProps } from '.';

export const AddedProductItemCoesMobile: React.FC<AddedProductResponsiveItemCoesProps> = ({
  data,
  additionalInfoComponent,
  inputMoneyDataProps,
  onRemoveProduct,
  type,
}) => {
  return (
    <VStack w="full">
      <VStack w="full" space={Spacing['inset.nano']}>
        <TableContentItemText variant="bold" fontSize={Typography['fontsize.lg']}>
          {data.fantasyName} {data.asset}
        </TableContentItemText>
        <TableContentItemText color="neutral.medium">{data.strategy}</TableContentItemText>
      </VStack>
      <VStack space={Spacing['stack.nano']} w={'full'}>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Vencimento</TableContentItemText>
          <TableContentItemText>
            {Utils.Mask.DateFormat(data.maturityDate, 'dd/MM/yyyy')}
          </TableContentItemText>
        </TableContentItemColumn>
        {additionalInfoComponent}
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Risco</TableContentItemText>
          <RiskRating
            currentRiskRating={data?.suitabilityProductRisk?.scoreAdjusted || 0}
            tooltip={data?.suitabilityProductRisk?.risk || messageError}
          />
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Aplicação mín.</TableContentItemText>
          <TableContentItemText>{Utils.Mask.Money(data.minimumApplication)}</TableContentItemText>
        </TableContentItemColumn>
      </VStack>
      <TableContentItemColumn
        pt={Spacing['stack.nano']}
        space={Spacing['inline.quarck']}
        flex={1}
        w={'full'}>
        {type === 'requiredAttention' && (
          <VStack>
            <BillingTypeSelect data={data} />
          </VStack>
        )}
        <TableContentItemText>Valor a aplicar</TableContentItemText>
        <HStack w={'full'} alignContent={'center'} space={Spacing['stack.xxxs']}>
          <InputMoney {...inputMoneyDataProps} />
          <IconButton
            testId="icon-button"
            borderRadius={BoxRadius.sm}
            icon="Trash"
            p={0}
            iconColor={Color['feedback.error.default']}
            iconSize="xs"
            onPress={onRemoveProduct}
          />
        </HStack>
      </TableContentItemColumn>
    </VStack>
  );
};
